module.exports = __webpack_public_path__ + "img/payment.8eed7d35.svg";